<template>
     <div class="box">
        <div class="box-header box-clearfix">
            <div class="box-title">
                <a href="javascript:;">Security Settings</a>
            </div>
        </div>
        <div class="box-body">
          <el-form :model="formVal" :rules="formRules" label-position="right" label-width="140px" ref="formVal" class="security-box">
            <el-form-item label="Original password：" prop="original_password" class="form-row password-row">
                <div class="btn-show-password" @click="togglePw('original_passType')" :class="{'open':original_passType==='text'}"></div>
                <el-input :type="original_passType" v-model="formVal.original_password" auto-complete="off"></el-input>
            </el-form-item> 
            <el-form-item label="New password:" prop="password" class="form-row password-row">
                <div class="btn-show-password" @click="togglePw('passType')" :class="{'open':passType==='text'}"></div>
                <el-input :type="passType" v-model="formVal.password" auto-complete="off"></el-input>
            </el-form-item>  
            <el-form-item label="Confirm password:" prop="confirm_password" class="form-row password-row">
                <div class="btn-show-password"  @click="togglePw('confirm_passType')" :class="{'open':confirm_passType==='text'}"></div>
                <el-input :type="confirm_passType" v-model="formVal.confirm_password" auto-complete="off"></el-input>
            </el-form-item>  
            <div class="form-row form-button">
              <el-button @click="submitForm('formVal')" :loading="isLoading">Confirm</el-button>
            </div> 
          </el-form>
        </div>
        <el-dialog
          :visible="isSuccess"
          width="520px"
          :show-close='false'
          custom-class='security-box-msgbox'
          center>
          <div style="text-align:center">
            <div class="ico-box ico-success"></div>
            <p>Congratulations!</p>Password reset was successful. Please login again to MyZFX.
          </div>
          <span slot="footer" class="dialog-footer"></span>
        </el-dialog>
     </div>
</template>

<script>
import { validatePass } from 'utils/validate'
import { resetPassword } from './action/index'
import { logout } from '../../service/login'
export default {
  data() {
    let validateCheckPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the password again.'))
      } else if (value !== this.formVal.password) {
        callback(new Error('The two input password is not consistent!'))
      } else {
        callback()
      }
    }
    let validateCheckPassNotTheSame = (rule, value, callback) => {
      if (value === this.formVal.original_password) {
        callback(
          new Error(
            'The new password cannot be the same as the original password!'
          )
        )
      } else {
        callback()
      }
    }
    return {
      isLoading: false,
      isSuccess: false,
      original_passType: 'password',
      passType: 'password',
      confirm_passType: 'password',
      formVal: {
        original_password: '',
        password: '',
        confirm_password: ''
      },
      formRules: {
        original_password: [{ validator: validatePass, trigger: 'blur' }],
        password: [
          { validator: validatePass, trigger: 'blur' },
          { validator: validateCheckPassNotTheSame, trigger: 'blur' }
        ],
        confirm_password: [{ validator: validateCheckPass, trigger: 'blur' }]
      }
    }
  },
  created() {
    window.vuex_store.commit('set_title', 'Account Settings')
  },
  methods: {
    togglePw(typename) {
      if (this[typename] === 'password') {
        this[typename] = 'text'
      } else {
        this[typename] = 'password'
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        console.log('valid', valid)
        if (valid) {
          this.isLoading = true
          resetPassword({
            original_password: this.formVal.original_password,
            password: this.formVal.password
          })
            .then(() => {
              this.isSend = true
              this.isLoading = false
              this.isSuccess = true
              setTimeout(() => {
                this.isSuccess = false
                logout().then(() => {
                  localStorage.uk_token = ''
                  this.$router.push({ name: 'login' })
                })
              }, 2000)
            })
            .catch(() => {
              this.isLoading = false
            })
        } else {
          console.log('error submit!')
          return false
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '~assets/css/helper/variables.scss';
@import '~assets/css/helper/mixin';
.security-box {
  width: 371px;
  margin-left: 280px;
  margin-top: 90px;
  .form-button button {
    margin-left: 150px;
    width: 221px;
    height: 42px;
    line-height: 42px;
    padding: 0;
    background:  #0A95FF;
    border-radius: 4px;
    text-align: center;
    color: #fff;
    border: none;
    margin-bottom: 140px;
  }
  .password-row {
    position: relative;
    .btn-show-password {
      position: absolute;
      right: 0;
      top: 0;
      z-index: 3;
      width: 50px;
      height: 40px;
      cursor: pointer;
      background: url(~assets/img/ico-eye-close-s.png) no-repeat center center;
      &.open {
        background: url(~assets/img/ico-eye-open-s.png) no-repeat center center;
      }
      &:hover {
        opacity: 0.8;
      }
    }
  }
  .el-form-item__error {
    width: 400px;
  }
  &-msgbox {
    &.el-message-box--center {
      width: 520px;
      padding: 30px 0 60px 0;
    }
    .ico-box {
      width: 60px;
      height: 60px;
      margin: 0 auto 25px auto;
      &.ico-success {
        background: url('~assets/img/ico-successful.png');
      }
      &.ico-failed {
        background: url('~assets/img/ico-failed.png');
      }
      &.ico-warning {
        background: url('~assets/img/ico-warning.png');
      }
    }
  }
}
</style>
